module.exports = __webpack_public_path__ + "img/img10.41404376.svg";